define('app-Recaptcha/main',["./settings"], function (settings) {
    var container = $(settings.container);

    if (container.length === 0) {
        return null;
    }

    var module = {};

    module.reCaptchaCallback = function (response) {
        if (response === "") {
            var warningElement = $(settings.recaptchaWarning);
            warningElement.show();
        }
    }

    module.validateRecapture = function(event, callback) {
        var response = grecaptcha.getResponse();
        if (response == "") {
            $(settings.recaptchaWarning).css("display", "block");
            event.preventDefault();
            return;
        } else {
            if (callback) {
                callback();
            }
        };
    };
    return module;
});
